import { Button, Card, Empty, Table, Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '@/services/api.service';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

type Preview = { eligible: number; exceptions: Array<{ item_id: string; student_id: string; code: string }> };

export default function ProgressionExceptionsPage() {
  const { t } = useTranslation('education');
  const { id } = useParams();
  const navigate = useNavigate();
  const preview = useQuery({
    queryKey: ['education-progression-exceptions', id],
    queryFn: () => api.post<Preview>(`/education/progression-batches/${id}/preview`, {}),
  });
  const rows = preview.data?.data?.exceptions || [];
  const eligible = preview.data?.data?.eligible ?? 0;

  return (
    <EducationPageChrome
      title={t('progressionExceptions')}
      description={t('progressionIntro')}
      tags={
        <>
          <Tag color="green">{eligible} {t('eligible')}</Tag>
          <Tag color={rows.length ? 'orange' : 'default'}>{rows.length} {t('exception')}</Tag>
        </>
      }
      extra={<Button onClick={() => navigate('/education/progression')}>{t('backToProgression')}</Button>}
    >
      <Card size="small">
        <Table
          rowKey={(row) => `${row.item_id}-${row.code}`}
          loading={preview.isLoading}
          dataSource={rows}
          pagination={{ pageSize: 20, showSizeChanger: true }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t('noExceptions', { defaultValue: 'No exceptions in this preview' })}
              />
            ),
          }}
          columns={[
            { title: t('studentId'), dataIndex: 'student_id' },
            {
              title: t('exception'),
              dataIndex: 'code',
              render: (value: string) => <Tag color="orange">{value}</Tag>,
            },
          ]}
        />
      </Card>
    </EducationPageChrome>
  );
}
